import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsFillExclamationCircleFill } from 'react-icons/bs';

const ContractAlert = (props) => {
  // eslint-disable-next-line no-unused-vars

  const { message } = props;

  return (
    <>
      <div className="d-flex justify-content-center align-items-center py-o">
        <h6 className="text-warning text-sm mb-0">Contrato</h6>
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={
            <Tooltip id="button-tooltip">
              {message?.map((mes) => (
                <>
                  {mes}
                  <br />
                </>
              ))}
            </Tooltip>
          }
          placement="top"
        >
          <button
            aria-label="alert"
            className="d-flex justify-content-center align-item-center"
            type="button"
          >
            <BsFillExclamationCircleFill
              color="#ff973d"
              style={{
                marginTop: '5px'
              }}
            />
          </button>
        </OverlayTrigger>
      </div>
    </>
  );
};

export default ContractAlert;

ContractAlert.propTypes = {
  message: PropTypes.arrayOf(PropTypes.string).isRequired
};
